module.exports = __webpack_public_path__ + "static/media/bikeMidground.46a1fe4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Bike/bikeMidground.svg
// module id = 910
// module chunks = 0